import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_WORKOUTS_FROM_CERTAIN_SUBSCRIPTION_SAGA } from "../sagaTypes";
import { loaderAction, currentSubscriptionAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_workouts_from_certain_subscription`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetWorkoutsFromSpecificSubscription(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('subscription_id', args.data.subscription_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(currentSubscriptionAction(response.subscription_info));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetWorkoutsFromCertainSubscription() {
    yield takeLatest(GET_WORKOUTS_FROM_CERTAIN_SUBSCRIPTION_SAGA, workerGetWorkoutsFromSpecificSubscription);
}